import { createFileRoute } from '@tanstack/react-router';

import { getInvoiceQueryOptions } from '@/_pages/invoices/api-service';
import Loading from '@/_pages/invoices/profile/loading';

export const Route = createFileRoute('/_private/invoices/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getInvoiceQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
